/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import SimpliCityAdminSDK from "@simplicitycms/simplicity-admin-js-sdk";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { useAuth } from "cms/auth/hooks/use-auth";
import { EntityEditor } from "cms/entity/entity-editor";
import debounce from "lodash.debounce";
import { generateGuid, isStringNotEmpty } from "utils/empty-exists";
import { Logger, magentaBright } from "cms/utils/log/logger";
import { useUpdateModel } from "hooks/use-update-model";
import { dispatch } from "data/store";
import { setCurrentEntity, setEntitySchemas } from "data/store/reducers/entity";
// import { EntityDialog } from "../../../../entity/entity-dialog/entity-dialog";
// import { Button } from "@mui/material";
// import { EntityDialogButton } from "../../../../entity/entity-dialog/entity-dialog-button";

const EntityFieldItemEdit = () => {
    
    const { token } = useAuth();
    const {
        // type,
        // name,
        index,
        value,
        settings,
        updateListItem,
        // disabled = false,
        // defaultImpl
    } = useContext(ListItemContext);

    const { markModel } = useUpdateModel();
    
    const ENTITY_TYPE = "entity.dispute";
    
    const guid = value;
    
    // field state
    const [itemLocalState, setItemLocalState] = useState({ value, settings });
    
    const entity_guid = useMemo(() => {
        return guid;
    }, [guid]);
    
    const saveEntity = async (entity) => {
        let response;
        if (!entity?.guid) {
            const guid = generateGuid();
            const key = guid;
            const data = { ...entity, guid, key };
            Logger.info(`create entity ${guid}`);
            Logger.info(data);
            response = await SimpliCityAdminSDK.entity.create(token, data);
            //console.info(response);
        } else {
            const data = { ...entity };
            const guid = entity?.guid;
            Logger.info(`update entity ${guid}`);
            Logger.info(data);
            response = await SimpliCityAdminSDK.entity.update(token, guid, data);
            //console.info(response);
        }
        // setModified(false);
        await markModel();
        return response;
    };
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 700),
        [updateListItem]
    );
    
    const onEntityChange = async (_entity) => {
        Logger.info(magentaBright(`saving entity and field value`));
        //console.log(_entity);
        dispatch(setCurrentEntity(_entity));
        const response = await saveEntity(_entity);
        const _guid = response?.guid ?? "";
        const updatedState = {
            ...itemLocalState,
            value: _guid
        };
        setItemLocalState(updatedState);
        update(updatedState, index);
    };

    useEffect(() => {
        const loadEntityData = async () => {
            const _schema = await SimpliCityAdminSDK.entity.schemas.find(token);
            setEntitySchemas(_schema);
            dispatch(setEntitySchemas(_schema));
            
            if (isStringNotEmpty(entity_guid)) {
                // TODO: load entity schemas once at startup
                const _entity = await SimpliCityAdminSDK.entity.findOne(token, entity_guid);
                dispatch(setCurrentEntity(_entity));
            } else {
                // TODO: Generate from schema
                const _entity = {
                    type: ENTITY_TYPE,
                    date: "",
                    time: "",
                    municipality: "",
                    ticket: "",
                    disputant: "",
                    evidence: []
                };
                dispatch(setCurrentEntity(_entity));
            }
        };
        loadEntityData();

    }, [token, entity_guid]);
    
    return (
        <>
            <div className='simplicity-composer-field-primary-layout'>
                <div className="document-display" style={{
                    display: "flex", flexDirection: "column", width: "100%", height: "100%"
                    // flex: '1', border: `1px solid #CFCFCF`, padding: 12,
                }}
                >
                    {/*<EntityDialogButton*/}
                    {/*    update={() => {}}*/}
                    {/*    guid={guid}*/}
                    {/*/>*/}
                    
                    <EntityEditor
                        // entity={entity}
                        // schema={schema}
                        onEntityChange={onEntityChange}
                    />

                    {/*<div style={{ fontWeight: "700"}}>value</div>*/}
                    {/*<pre style={{ fontSize: "9px", width: "800px", padding: "1rem", overflowX: "auto", backgroundColor: "#ddddff" }}>*/}
                    {/*    {JSON.stringify(value, null, 2)}*/}
                    {/*</pre>*/}

                </div>
            </div>
        </>
    );
};
EntityFieldItemEdit.displayName = "EntityFieldItemEdit";
export { EntityFieldItemEdit };
